class Cart extends HTMLElement {
  constructor() {
    super();
    this.emptyBlocksCarousels = [];
    this.upsellRequest = null;
    this.handleToggleDrawerCart();
    this.handleQuantityFields();
    this.handleAddToCart();
    this.handleEmptyBlocksCarousels();
  }
   
  // The upsell markup lives in sections/cart-upsell.liquid and is pulled in the first time the
  // drawer opens. Rendering it inline meant ~100KB of hidden markup on every page of the site,
  // for eight products most visitors never scrolled to. Routed through Shopify.routes.root so
  // the market/locale context is preserved and prices come back in the presentment currency.
  ensureCartUpsell() {
    if (this.upsellRequest) return this.upsellRequest;

    const slots = document.querySelectorAll('.js-cart-upsell-slot');
    if (!slots.length) return null;

    const root = window.Shopify?.routes?.root || '/';

    this.upsellRequest = fetch(`${root}?sections=cart-upsell`)
      .then((response) => (response.ok ? response.json() : Promise.reject(response.status)))
      .then((data) => {
        const markup = data['cart-upsell'];
        if (!markup) return;

        const parsed = new DOMParser().parseFromString(markup, 'text/html');

        slots.forEach((slot) => {
          const source = parsed.querySelector(`[data-upsell-slot="${slot.dataset.upsellSlot}"]`);
          if (source) slot.innerHTML = source.innerHTML;
        });

        // Clicks are delegated on document and keep working, but the variant lookup and
        // intersection observers are bound per element, so the injected cards need wiring.
        if (typeof window.observeGridItems === 'function') window.observeGridItems();
      })
      .catch(() => {
        // The drawer is perfectly usable without the upsell — clear the guard so the next
        // open can try again rather than leaving the slots permanently empty.
        this.upsellRequest = null;
      });

    return this.upsellRequest;
  }

  handleToggleDrawerCart() {
    document.querySelectorAll('.js-open-drawer-cart').forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const drawer = document.querySelector('.js-drawer-cart');
        if (!drawer) return;

        this.ensureCartUpsell();

        drawer.classList.add('display');
        if (window.lenis) {
          window.lenis.stop();
        } else {
          document.body.style.overflow = "hidden";
        }

        setTimeout(() => {
          drawer.classList.add('active');
        }, 50);
      });
    });

    document.querySelectorAll('.js-close-drawer-cart').forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const drawer = document.querySelector('.js-drawer-cart');
        if (!drawer) return;

        drawer.classList.add('closing');

        setTimeout(() => {
          drawer.classList.remove('active', 'closing', 'display');
          if (window.lenis) {
            window.lenis.start();
          } else {
            document.body.style.overflow = "visible";
          }
        }, 300);
      });
    });
  }

  handleQuantityFields() {
    const self = this;
    document.body.addEventListener('click', (event) => {
			const target = event.target.closest('.js-change-quantity');
			if (!target) return;

      event.preventDefault();
  
      target.classList.add('loading');
			  
			const variantId = parseInt(target.getAttribute('data-variant-id'), 10);
			let quantity = parseInt(target.getAttribute('data-quantity'), 10);
      const container = target.closest('.js-quantity-fields');

      container.querySelector('.js-quantity-minus').setAttribute('data-quantity', quantity - 1);
      container.querySelector('.js-quantity-plus').setAttribute('data-quantity', quantity + 1);

      const cartItem = container.closest('.js-cart-item');
      cartItem.style.height = `${cartItem.offsetHeight}px`;
			  
      var formData = new FormData();
      formData.append("updates[" + variantId + "]", quantity);

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(response => {
        document.querySelectorAll('.js-change-quantity').forEach(el => el.classList.remove('loading'));
				const subtotalElement = document.querySelector('.js-subtotal-price');
				if (subtotalElement) {
					subtotalElement.innerHTML = Shopify.formatMoney(response.total_price, moneyWithCurrencyFormat);
				}
        
        if (quantity < 1) {
          cartItem.classList.add('hide-item');
          setTimeout(() => {
            cartItem.classList.add('hidden');
            if (response.total_price === 0) {
              document.querySelector('.js-cart-content').classList.add('drawer-cart__content--empty');
            }
          }, 300);
        } else {
          container.querySelector('.js-quantity-field-input').value = quantity;
        }

        cartItem.setAttribute('data-quantity', quantity);
        
				document.querySelectorAll('.js-cart-counter').forEach(cartCounter => {
				  cartCounter.innerHTML = response.item_count;
				  cartCounter.setAttribute('data-counter', response.item_count);
				});
      })
      .catch(error => {
        alert(error.message || 'Error');
        document.querySelectorAll('.js-change-quantity').forEach(el => el.classList.remove('loading'));
      });
    });
  }

  handleAddToCart() {
    const self = this;

		document.body.addEventListener("click", function (event) {
      const target = event.target.closest(".js-add-to-cart");
	    if (!target) return;

	    event.preventDefault();

      target.getAttribute("data-adding-text") && (target.innerHTML = target.getAttribute("data-adding-text"));
      target.classList.add("loading");

      if (target.closest(".js-mobile-add-to-cart")) {
        return;
      }

      let id = null;
      let quantity = 1;

      const gridItem = target.closest(".js-product-grid-item");

      if (gridItem?.dataset.currentVariantId) {
        id = parseInt(gridItem.dataset.currentVariantId, 10);
        quantity = 1;
      } else {
        let productId = target.getAttribute("data-product-id");
        let productElement = document.querySelector(`.js-product[data-product-id='${productId}']`);

        quantity = productElement?.querySelector(".js-quantity-field")?.value || 1;
        if (isNaN(quantity) || !quantity) quantity = 1;

        id = productElement
          ? parseInt(productElement.querySelector(`#product-select-${productId}`)?.value, 10)
          : null;
      }

      let featuredImage = target.getAttribute("data-featured-image") || null;

      let formData = {
       'items': [{
          'id': parseInt(id, 10),
          'quantity': parseInt(quantity, 10)
        }]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(async response => {
        if (!response.ok) {
          const errorData = await response.json();
          const error = new Error(errorData.description || 'Something went wrong');
          error.status = response.status;
          throw error;
        }
        return response.json();
      })
      .then(response => {
        response = response.items.find(item => item.id === parseInt(id, 10));

        // Fires on a confirmed add, not on the click, so the funnel is not inflated by
        // failed adds. The lead-image properties are read off the PDP element rather
        // than from a Mixpanel super-property: super-properties persist across pages,
        // so a grid add would otherwise inherit whichever PDP was viewed last. Adds
        // from a collection grid have no .js-product, so they simply carry no pdp_lead_*
        // and drop out of the breakdown instead of polluting it.
        if (window.mixpanel && typeof window.mixpanel.track === 'function') {
          const pdp = gridItem ? null : document.querySelector(`.js-product[data-product-id='${target.getAttribute('data-product-id')}']`);
          const props = {
            product_id: response.product_id,
            variant_id: response.variant_id,
            quantity: response.quantity,
            source: gridItem ? 'grid' : 'pdp'
          };

          if (pdp) {
            props.product_handle = pdp.dataset.productHandle;
            props.pdp_lead_image = pdp.dataset.leadImage;
            props.pdp_lead_type = pdp.dataset.leadType;
            props.pdp_gallery_order = pdp.dataset.galleryOrder;

            // The choice set — every lifestyle shot this product could have led with,
            // labelled the same way as pdp_lead_image so "contains" lines up. An array,
            // so Mixpanel can filter on it.
            try {
              props.pdp_media_images = JSON.parse(pdp.dataset.mediaImages || '[]');
            } catch (e) {
              // A malformed attribute should cost us the inventory, not the whole event.
            }
          }

          // "PDP Add to Cart", not "Product Added to Cart": the store's Shopify web pixel
          // already emits that name, and the pixel is sandboxed so it can never carry the
          // pdp_lead_* properties. Two sources under one name would double-count the funnel.
          window.mixpanel.track('PDP Add to Cart', props);
        }

        self.hideUpsellProductInCart(response.product_id);

        let variantId = response.variant_id;
        let cartItem = document.querySelector(`.js-cart-item[data-variant-id='${variantId}']:not(.hidden)`);

        if (cartItem) {
          let quantityField = cartItem.querySelector(".js-quantity-field-input");
          let quantityMinus = cartItem.querySelector(".js-quantity-minus");
          let quantityPlus = cartItem.querySelector(".js-quantity-plus");

          quantityField.value = response.quantity;
          quantityMinus.setAttribute("data-quantity", response.quantity - 1);
          quantityPlus.setAttribute("data-quantity", response.quantity + 1);
        } else {
          let quantityMinus = response.quantity - 1;
          let quantityPlus = response.quantity + 1;
          
          let image = featuredImage || response.image;

          let item = `
          <li class="cart-item d-flex js-cart-item" data-variant-id="${response.variant_id}" data-quantity="${response.quantity}">
            <div class="cart-item__image">
              <a href="${response.url}">
                <img src="${image}" width="668px" height="768px" alt="${response.product_title}" />
              </a>
            </div>

            <div class="cart-item__details d-flex">
              <div class="cart-item__top d-flex">
                <div class="cart-item__top-left">
                  <div class="cart-item__title">
                    <a href="${response.url}">${response.product_title}</a>
                  </div>

                  ${(response.options_with_values || [])
                    .filter(option => option.name !== 'Title')
                    .map(option => `<div class="cart-item__option">${option.value}</div>`)
                    .join('')}
                </div>

                <div class="cart-item__top-right">
                  <div class="cart-item__price">${Shopify.formatMoney(response.final_price, moneyWithCurrencyFormat)}</div>
                </div>
              </div>

              <div class="cart-product__quantity-and-delete d-flex align-items-center js-quantity-fields">
                <div class="cart-product__quantity-field">
                  <div class="quantity-field__minus">
                    <a href="#" class="js-change-quantity js-quantity-minus" data-variant-id="${response.variant_id}" data-quantity="${Math.max(0, response.quantity - 1)}">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.66667 5.66602H3.33333C3.14924 5.66602 3 5.81525 3 5.99935C3 6.18344 3.14924 6.33268 3.33333 6.33268H8.66667C8.85076 6.33268 9 6.18344 9 5.99935C9 5.81525 8.85076 5.66602 8.66667 5.66602Z" fill="black"/>
                      </svg>
                    </a>
                  </div>

                  <input type="text" value="${response.quantity}" class="quantity-field__input js-quantity-field-input" disabled="disabled" />

                  <div class="quantity-field__plus">
                    <a href="#" class="js-change-quantity js-quantity-plus" data-variant-id="${response.variant_id}" data-quantity="${response.quantity + 1}">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.0001 5.66602H6.33339V1.99935C6.33339 1.81525 6.18415 1.66602 6.00006 1.66602C5.81596 1.66602 5.66672 1.81525 5.66672 1.99935V5.66602H2.00006C1.81596 5.66602 1.66672 5.81525 1.66672 5.99935C1.66339 6.087 1.69817 6.1718 1.76208 6.23187C1.82599 6.29195 1.91278 6.32142 2.00006 6.31268H5.66672V9.99935C5.66672 10.1834 5.81596 10.3327 6.00006 10.3327C6.18415 10.3327 6.33339 10.1834 6.33339 9.99935V6.33268H10.0001C10.1842 6.33268 10.3334 6.18344 10.3334 5.99935C10.3334 5.81525 10.1842 5.66602 10.0001 5.66602Z" fill="black"/>
                      </svg>
                    </a>
                  </div>
                </div>

                <div class="cart-item__delete">
                  <a href="#" class="js-change-quantity" data-variant-id="${response.variant_id}" data-quantity="0">Remove</a>
                </div>
              </div>
            </div>
          </li>`;

          document.querySelector(".js-cart-items").insertAdjacentHTML("beforeend", item);
          if (typeof initializeObservers === "function") {
            initializeObservers();
          }
        }

        return fetch(window.Shopify.routes.root + 'cart.js').then(response => response.json());
	    })
	    .then(cart => {
        if (typeof ProductGridLazyVariants !== "undefined") {
          ProductGridLazyVariants.closeMobileAddToCart();
        }
        document.querySelectorAll(".js-change-quantity").forEach(el => el.classList.remove("loading"));
				const subtotalElement = document.querySelector('.js-subtotal-price');
				if (subtotalElement) {
					subtotalElement.innerHTML = Shopify.formatMoney(cart.total_price, moneyWithCurrencyFormat);
				}

        document.querySelector(".js-cart-content")?.classList.remove("drawer-cart__content--empty");
				document.querySelectorAll('.js-cart-counter').forEach(cartCounter => {
				  cartCounter.innerHTML = cart.item_count;
				  cartCounter.setAttribute('data-counter', cart.item_count);
				});
        // `self`, not `this` — the enclosing click listener is a plain function, so `this`
        // in here is document.body. handleAddToCart already captures the element as `self`.
        self.ensureCartUpsell();
        document.querySelector('.js-drawer-cart')?.classList.add('display');
        setTimeout(() => {
          document.querySelector('.js-drawer-cart')?.classList.add('active');
        }, 50);
        if (window.lenis) {
          window.lenis.stop();
        } else {
          document.body.style.overflow = "hidden";
        }
        document.querySelectorAll('.js-add-to-cart').forEach(button => {
          const originalText = button.getAttribute('data-original-text');
          button.textContent = originalText;
        });
	    })
      .catch(async (error) => {
        let message = 'Unexpected error';

        try {
          const text = await error.text();
          const json = JSON.parse(text);
          if (json && json.description) {
            message = json.description;
          }
        } catch (e) {
          message = error.message || 'Something went wrong';
        }

        alert(message);
        window.location.reload();
      });
		});
  }

  hideUpsellProductInCart(productId) {
    if (!productId) return;

    const styleId = 'cart-products-hidden-css';
    let style = document.getElementById(styleId);

    if (!style) {
      style = document.createElement('style');
      style.id = styleId;
      document.head.appendChild(style);
    }

    const rule = `
      .cart-upsell .product-grid-item[data-product-id-2="${productId}"] {
        display: none !important;
      }
    `;

    if (!style.textContent.includes(`data-product-id-2="${productId}"`)) {
      style.textContent += rule;
    }
  }

  handleEmptyBlocksCarousels() {
    const self = this;

    function initEmptyBlocksCarousels() {
      if (typeof Splide === 'undefined') return;

      document.querySelectorAll('.js-drawer-cart-empty-blocks-carousel').forEach((carousel) => {
        if (carousel.classList.contains('is-initialized')) return;

        carousel.classList.add('is-initialized');

        const splide = new Splide(carousel, {
          type: 'slide',
          perPage: 1,
          perMove: 1,
          gap: 16,
          pagination: true,
          arrows: false,
          drag: true,
          destroy: false,

          breakpoints: {
            991: {
              destroy: true
            }
          }
        });

        splide.mount();
        if (typeof window.enableSplideWheelNav === "function") {
          window.enableSplideWheelNav(splide, carousel);
        }
        self.emptyBlocksCarousels.push(splide);
      });
    }

    function destroyEmptyBlocksCarousels() {
      self.emptyBlocksCarousels.forEach((splide) => {
        if (splide && splide.destroy) {
          splide.destroy(true);
        }
      });

      self.emptyBlocksCarousels = [];

      document.querySelectorAll('.js-drawer-cart-empty-blocks-carousel').forEach((carousel) => {
        carousel.classList.remove('is-initialized');
      });
    }

    function handleResize() {
      if (window.innerWidth > 991) {
        initEmptyBlocksCarousels();
      } else {
        destroyEmptyBlocksCarousels();
      }
    }

    handleResize();

    window.addEventListener('resize', () => {
      clearTimeout(self.emptyBlocksCarouselsResizeTimer);

      self.emptyBlocksCarouselsResizeTimer = setTimeout(() => {
        handleResize();
      }, 200);
    });
  }
}

customElements.define('drawer-cart', Cart);